<template>
  <div class="customer-select" :class="{ 'is-empty': !selectCustomer }">
    <div class="title" @click="drawer = true">{{ selectCustomer || '客户选择' }}</div>
    <i v-if="!selectCustomer" class="icon-arrow-down-s-line t-iconfont" @click="drawer = true"></i>
    <i v-else class="icon-close-circle-line t-iconfont" @click="handleClearCustomer"></i>
    <el-drawer v-model="drawer" direction="btt" :show-close="false" size="60%" :with-header="false">
      <div class="drawer-content">
        <div class="head">
          <div class="left"></div>
          <div class="center">客户</div>
          <div class="right">
            <i class="icon-close-line t-iconfont" @click="drawer = false"></i>
          </div>
        </div>
        <div class="content">
          <van-cell-group inset>
            <van-field
              v-model="nameLike"
              clearable
              placeholder="搜索客户"
              @clear="handleClearSearch"
              @update:model-value="handleSearchInput"
            />
          </van-cell-group>
          <div v-loading="searchLoading" class="customer-select-content">
            <template v-for="(customer, index) in options" :key="index">
              <div class="customer-item" @click="handleClickCustomer(customer)">
                <span>{{ customer.label }}</span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { getCustomerOption } from '@/api/ai-board'

defineProps({
  value: {
    type: [String, Number],
    default: ''
  }
})

const emits = defineEmits(['update:value', 'selectUser'])

const selectCustomer = ref('')
const drawer = ref(false)
const timeout = ref(null)
const nameLike = ref('')
const searchLoading = ref(true)
const options = ref([])

const handleClearCustomer = () => {
  selectCustomer.value = ''
  emits('update:value', '')
  emits('selectUser')
}

const handleClickCustomer = (item) => {
  console.log(item)
  drawer.value = false
  selectCustomer.value = item.label
  emits('update:value', item.value)
  emits('selectUser')
}

const handleSearchInput = () => {
  searchLoading.value = true
  clearTimeout(timeout.value)
  timeout.value = setTimeout(() => {
    getOptions(nameLike.value)
  }, 500)
}

const handleClearSearch = () => {
  nameLike.value = ''
}

const getOptions = (nameLike = '') => {
  getCustomerOption({
    customerNameLike: nameLike
  })
    .then((res) => {
      options.value = res.result.customerList.map((item) => {
        return {
          value: item.id,
          label: item.name
        }
      })
    })
    .finally(() => {
      searchLoading.value = false
    })
}

onMounted(() => {
  getOptions()
})
</script>

<style lang="scss" scoped>
.customer-select {
  flex: 0 0 auto;
  width: 132px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #f7f8fa;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: PingFang SC;
  font-size: 14px;
  line-height: 20px;
  color: #323233;
  .title {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  :deep(.el-drawer) {
    border-radius: 20px 20px 0px 0px;
  }
  .drawer-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
    .left {
      flex: 0 0 52px;
    }
    .right {
      flex: 0 0 52px;
      text-align: right;
      color: #969799;
      font-size: 20px;
    }
    .head {
      flex: 0 0 auto;
      overflow: hidden;
      text-align: center;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 13px 16px;
      /* 三级文字/常规 */
      font-family: PingFang SC;
      font-size: 16px;
      line-height: 22px;

      color: #323233;
    }
    .content {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      :deep(.van-field) {
        background: #f7f8fa;
      }
      :deep(.van-cell) {
        padding: 6px 16px;
      }
      :deep(.van-cell-group--inset) {
        flex: 0 0 auto;
        margin: 12px;
      }
      .customer-select-content {
        flex: 1;
        overflow-y: auto;
        padding: 16px;
        .customer-item {
          display: flex;
          align-items: center;
          padding: 6px 0;
          box-sizing: border-box;
          span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .user-select-empty {
        padding: 16px;
        text-align: center;
      }
    }
  }
}

.is-empty {
  .title {
    margin-left: 8px;
    font-family: PingFang SC;
    font-size: 14px;
    line-height: 20px;
    color: #c8c9cc;
  }
  i {
    color: #c8c9cc;
  }
}
</style>
